import script from "./AdminTelegramTopics.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTelegramTopics.vue?vue&type=script&setup=true&lang=js"

import "./AdminTelegramTopics.vue?vue&type=style&index=0&id=40abb104&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40abb104"]])

export default __exports__